module.exports = __webpack_public_path__ + "static/img/icon-hotel-type2.fcd9333c.png";